import { L10n, setCulture } from '@syncfusion/ej2-base'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { applyMiddleware, combineReducers, createStore, ReducersMapObject } from 'redux'
import '../node_modules/font-awesome/scss/font-awesome.scss'
import App from './App/index'
import './assets/scss/style.scss'
import config from './config'
import * as EJ2_LOCALE from './locale.pl.json'
import { ApplicationState, reducers } from './store'
import apiMiddleware from './store/apiMiddleware'
import './styles/compatibility/bootstrap4.min.css'
import SignIn from './views/SignIn/SignIn'

require('./utils/api')
L10n.load({ pl: EJ2_LOCALE.pl })
setCulture('pl')

const token = localStorage.getItem('accessToken')

const component = token && token !== '' && token !== null ? <App/> : <SignIn/>

const allReducers = buildRootReducer(reducers)
const store = createStore(allReducers, applyMiddleware(apiMiddleware))

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter basename={config.basename}>
            {component}
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
)

function buildRootReducer (allReducers: ReducersMapObject<ApplicationState>) {
    return combineReducers<ApplicationState>(Object.assign({}, allReducers))
}
